export default __webpack_public_path__ + "static/media/569.2a37d6fb.gif";